/*!
	js-cookie
	Copyright	Klaus Hartl, Fagner Brack, GitHub Contributors
	License		MIT
	Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions: The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	Version		3.0.5

	https://github.com/js-cookie/js-cookie
*/
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}var t=function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"});return t}));
/*!
	Shopify.formatMoney
	Copyright	Stewart Knapman

	https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
*/
var Shopify=Shopify||{};Shopify.money_format=(typeof general!=='undefined'&&general.currency)?general.currency:'{{amount}}';Shopify.formatMoney=function(cents,format){if(typeof cents=='string'){cents=cents.replace('.','')}
	var value='';var placeholderRegex=/\{\{\s*(\w+)\s*\}\}/;var formatString=(format||this.money_format);function defaultOption(opt,def){return(typeof opt=='undefined'?def:opt)}
	function formatWithDelimiters(number,precision,thousands,decimal){precision=defaultOption(precision,2);thousands=defaultOption(thousands,',');decimal=defaultOption(decimal,'.');if(isNaN(number)||number==null){return 0}
		number=(number/100.0).toFixed(precision);var parts=number.split('.'),dollars=parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+thousands),cents=parts[1]?(decimal+parts[1]):'';return dollars+cents}
	switch(formatString.match(placeholderRegex)[1]){case 'amount':value=formatWithDelimiters(cents,2);break;case 'amount_no_decimals':value=formatWithDelimiters(cents,0);break;case 'amount_with_comma_separator':value=formatWithDelimiters(cents,2,'.',',');break;case 'amount_no_decimals_with_comma_separator':value=formatWithDelimiters(cents,0,'.',',');break}
	return formatString.replace(placeholderRegex,value)}


function createElementWithClass(tag, classList) {
	var tagElem = document.createElement(tag);
	if (!Array.isArray(classList)) {
		classList = [classList]
	}
	for (var i = 0; i < classList.length; i++) {
		tagElem.classList.add(classList[i])
	}
	return tagElem
}

// Tabs
function semanticTabs(en) {
	"use strict";
	var tabs_header = en.children[0],
		tabs_header_items = tabs_header.querySelectorAll("li"),
		tabs_content = en.children[1],
		active_class = 'active',
		custom_active_class = '',
		classes;
	if (en.classList.contains('btn')) {
		active_class = 'link-btn';
	}
	if (en.getAttribute('data-active-class')) {
		custom_active_class = en.getAttribute('data-active-class');
	}
	Array.from(tabs_content.children).forEach(function (el, index) {
		if (el.classList.contains('tab-closed')) {
			classes = 'tabs-header';
		} else {
			classes = 'tabs-header toggle';
		}
		el.setAttribute("data-index", tabs_header_items.length - index);
		el.innerHTML = '<a href="./" class="' + classes + '">Tabs Header</a> <div class="tabs-inner">' + el.innerHTML + "</div>"
	});
	Array.from(tabs_content.querySelectorAll(".tabs-header")).forEach(function (el) {
		el.addEventListener("click", function (e) {
			el.classList.toggle("toggle");
			e.preventDefault();
		})
	});
	Array.from(tabs_header_items).forEach(function (el, index) {
		el.setAttribute("data-index", tabs_header_items.length - index);
		var d = el.dataset.index,
			alias = el.children[0].innerHTML;
		Array.from(tabs_content.querySelectorAll('[data-index="' + d + '"] .tabs-header')).forEach(function (el) {
			el.innerHTML = alias;
		});
		if (!en.classList.contains("static")) {
			Array.from(el.querySelectorAll("a")).forEach(function (el) {
				el.addEventListener("click", function (e) {
					Array.from(tabs_header_items).forEach(function (el) {
						el.classList.remove(active_class);
						el.classList.remove(custom_active_class);
						el.classList.remove('active');
					});
					el.parentElement.classList.add(active_class);
					el.parentElement.classList.add(custom_active_class);
					Array.from(tabs_content.children).forEach(function (el) {
						el.classList.add("hidden");
						if (el.matches('[data-index="' + d + '"]')) {
							el.classList.remove("hidden");
						}
					});
					e.preventDefault();
				})
			})
		}
	})
}